import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import NavBarWeb from "./layouts/NavBar.web";
import NavBarMob from "./layouts/NavBar.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";

const NavbarComponent = withConditionalComponent(NavBarWeb, NavBarMob);

export default function NavBar() {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return <div className="flex items-center w-full justify-center">
    <NavbarComponent trigger={isLargeScreen}/>
  </div>
}
